/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Navigation/AngleRight': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M24.145 15.236L10.88 4.06a.25.25 0 00-.352.029l-.97 1.146a.248.248 0 00.03.352L21.952 16 9.589 26.414a.248.248 0 00-.03.352l.97 1.146a.25.25 0 00.352.029l13.264-11.176c.473-.4.473-1.13 0-1.53"/>'
  }
})
